import { Box, Grid, Stack, Typography } from "@mui/material";
import { memo, useCallback } from "react";
import { ITopMedInternalSchedButtonProps } from "./models";
import { useNavigate } from "react-router-dom";
import ImportantDevicesIcon from "@mui/icons-material/ImportantDevices";
import { useTranslation } from "react-i18next";

const translationPath = "page.scheduleTeleconsultation.";

export const TopMedInternalSchedButton = memo(
  ({ description }: ITopMedInternalSchedButtonProps) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const clickHandler = useCallback(() => {
      navigate("/schedule-teleconsultation");
    }, [navigate]);

    return (
      <Grid item xs={12}>
        <Typography>{description}</Typography>
        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={(t) => ({
              p: 2,
              py: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
              border: `2px solid ${
                t.palette.grey[t.palette.mode === "light" ? 900 : 100]
              }`,
              borderRadius: t.shape.borderRadius,
              color: t.palette.text.primary,
              cursor: "pointer",
            })}
            onClick={clickHandler}
          >
            <Box sx={{ position: "relative" }}>
              <ImportantDevicesIcon color="primary" sx={{ fontSize: 45 }} />
              <Box
                sx={(t) => ({
                  width: 15,
                  height: 15,
                  background: t.palette.background.default,
                  position: "absolute",
                  top: "23%",
                  left: "28%",
                })}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                variant="h5"
                sx={{ fontSize: 18, fontWeight: "bold" }}
              >
                {t(translationPath + "schedule")}
              </Typography>
              <Typography variant="h5" fontWeight="bold">
                {t(translationPath + "teleconsultation")}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Grid>
    );
  }
);
